import firebase from 'firebase/app'
import 'firebase/firestore';
import 'firebase/messaging';
import 'firebase/storage';
import 'firebase/analytics';
// const dotenv = require('dotenv');
// dotenv.config();

var firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
  };

firebase.initializeApp(firebaseConfig)
// firebase.analytics();

// Initialize Cloud Firestore through Firebase
let db = firebase.firestore();
let storage = firebase.storage();

let messaging = null
if (firebase.messaging.isSupported()){
  messaging = firebase.messaging();
}
export default {
  db,
  storage,
  messaging
}
